/* eslint-disable react/jsx-closing-tag-location, quotes */
import { Button, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import AccountDropdown from "./AccountDropdown";
import { Default } from "./Devices";

const Header = ({
	headerMenu,
	helpPath,
	parentName,
	parentRoute,
	parentState,
	showHelp,
	title,
	userType
}) => (
	<header className="bg-white py-2 py-md-4 px-3 px-md-5 shadow-sm d-flex justify-content-between">
		<div className="d-flex justify-content-center justify-content-sm-start align-items-center">
			<Default>
				{
					parentName
						? <Nav.Link as={Link} className="ps-0 pe-0 pe-sm-2" state={parentState} to={parentRoute}>
							<Button className="ps-2 pe-3 me-0 me-sm-1" size="sm" variant="outline-secondary">
								<i className="bi bi-arrow-left-short" />

								<span>
									{`Back to ${parentName}`}
								</span>
							</Button>
						</Nav.Link>
						: ""
				}
			</Default>

			<h5 className="mb-0 d-block">
				{title}
			</h5>
		</div>

		<div className="d-flex justify-content-end justify-content-md-center my-2 my-sm-0" sm="auto" xs={12}>
			{
				showHelp && (
					<Nav.Item className="d-none d-lg-block">
						<Nav.Link as={Link} className="d-flex align-items-center" to={helpPath} >
							<i className={`fs-4 bi bi-question-circle pe-2 text-dark`} />

							<span className="mb-0 fs-6">
								Need Help?
							</span>
						</Nav.Link>
					</Nav.Item>
				)
			}

			{userType && <AccountDropdown headerMenu={headerMenu} userType={userType} />}

		</div>
	</header>
);

Header.propTypes = {
	headerMenu: PropTypes.arrayOf(PropTypes.object),
	helpPath: PropTypes.string,
	parentName: PropTypes.string,
	parentRoute: PropTypes.string,
	parentState: PropTypes.string,
	showHelp: PropTypes.bool,
	title: PropTypes.string.isRequired,
	userType: PropTypes.string.isRequired
};

Header.defaultProps = {
	headerMenu: null,
	helpPath: "",
	parentName: "",
	parentRoute: "",
	parentState: "",
	showHelp: false
};

export default Header;
